import { ADMIN_STATE_KEY } from "~/admin";
import { PRODUCT_IMPORT_STATE_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][PRODUCT_IMPORT_STATE_KEY];

export const getProductImportType = (state) => _getModuleState(state).importType;
